import { render, staticRenderFns } from "./AdminContentItemActions.vue?vue&type=template&id=61ef3454&"
import script from "./AdminContentItemActions.vue?vue&type=script&lang=ts&"
export * from "./AdminContentItemActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports